<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I can’t log in to my account / I forgot my password</h1>

			<div v-if="is_integrated">
				<p>
					You can login using your school credentials by clicking on login. Once you click, it will launch a login page, then bring you back here. If
					you
					have any errors, please follow the instructions on the log in page that launches.
				</p>

				<div class="h-login-form-box">
					<h3>Log in using your school credentials to view your order history</h3>
					<div class="h-login-form" v-html="login_form_html"></div>
				</div>
			</div>

			<div v-else>
				<!--<v-text-field type="email" label="Your Email" outline></v-text-field>-->
				<!--<v-btn>Reset Password</v-btn>-->
				<p>If you want to reset your password, please <a href="/account/forgot.php">click here</a></p>
			</div>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "CantLogin",

		components: {
			BaseNavLinks,
		},

		data() {
			return {
				login_form_html: '',
			};
		},

		computed: {
			is_integrated() {
				return this.$globs['institute_info'] && this.$globs['institute_info']['is_integrated_school'];
			}
		},

		mounted() {
			const self = this;

			if (self.$globs['login_form']) {
				self.login_form_html = self.$globs['login_form'];
			}
		},

	}
</script>

<style scoped lang="less">
	.h-login-form-box {
		width: 460px;
		border: 1px solid #d6d6d6;
		padding: 30px;
		margin-top: 50px;
		background-color: #DDEAFA;

		h3 {
			text-align: center;
			margin-bottom: 20px;
		}
	}
</style>